import React,{useState, useEffect} from 'react'
import {createOrderAction} from "../../store/order/actions"
import { useSelector,useDispatch } from "react-redux";
import {createUserAction} from "../../store/auth/actions"
import Layout from "../layout/Layout"


const Profile = () => {
    const { user } = useSelector((state: any) => state.auth);
    const dispatch = useDispatch<any>();
    const [fullName,setFullName] = useState("");
    const [email,setEmail] = useState("");
    const [password,setPassword] = useState("");

    const [address,setAddress] = useState("");
    const [phoneNumber,setPhoneNumber] = useState("");

   useEffect(() => {
    if(user){
        setFullName(user?.user?.names);
        setEmail(user?.user?.email);
        setAddress(user?.user?.address);
        setPhoneNumber(user?.user?.phone);


 
    }

   },[user])

  

  return (
    <Layout>
    {!user ?

    (<h1>Login first</h1>)

    :

    (

    <div className="cart-table-area section-padding-100">
    <div className="container-fluid">
        <div className="row">
            <div className="col-12 col-lg-8">
                <div className="checkout_details_area mt-50 clearfix">

                    <div className="cart-title">
                        <h2>Profile</h2>
                    </div>

                    <form action="#" method="post">
                        <div className="row">
                            <div className="col-md-12 mb-3">
                            <p><label>Full name</label></p>

                                <input type="text" className="form-control" id="first_name" value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Full Name" required/>
                            </div>
                            {/* <div className="col-md-6 mb-3">
                                <input type="text" className="form-control" id="last_name" value={secondName} onChange={(e) => setSecondName(e.target.value)} placeholder="Last Name" required/>
                            </div> */}
                            
                            <div className="col-12 mb-3">
                            <p><label>Email</label></p>

                                <input type="email" className="form-control" id="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                            </div>
                            <div className="col-12 mb-3">
                            <p><label>Password</label></p>

                                <input type="password" className="form-control" id="password" value={password} onChange={(e) => setPassword(e.target.value)}/>
                            </div>
                            {/* <div className="col-12 mb-3">
                                <select className="w-100" id="country">
                                <option value="usa">United States</option>
                                <option value="uk">United Kingdom</option>
                                <option value="ger">Germany</option>
                                <option value="fra">France</option>
                                <option value="ind">India</option>
                                <option value="aus">Australia</option>
                                <option value="bra">Brazil</option>
                                <option value="cana">Canada</option>
                                <option value="rw">Rwanda</option>

                            </select>
                            </div> */}
                            <div className="col-12 mb-3">
                            <p><label>Full address</label></p>

                                <input type="text" className="form-control mb-3" id="street_address" placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)}/>
                            </div>
                            {/* <div className="col-12 mb-3">
                                <input type="text" className="form-control" id="city" placeholder="Town" value={city} onChange={(e) => setCity(e.target.value)}/>
                            </div>
                            <div className="col-md-6 mb-3">
                                <input type="text" className="form-control" id="zipCode" placeholder="Zip Code" value={zipcode} onChange={(e) => setZipcode(e.target.value)}/>
                            </div> */}
                            <div className="col-md-12 mb-3">
                                <p><label>Phone number</label></p>
                                <input type="number" className="form-control" id="phone_number" min="0" placeholder="Phone No" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}/>
                            </div>
                            {/* <div className="col-12 mb-3">
                                <textarea name="comment" className="form-control w-100" id="comment" placeholder="Leave a comment about your order"></textarea>
                            </div> */}
{/* 
                            <div className="col-12">
                                <div className="custom-control custom-checkbox d-block mb-2">
                                    <input type="checkbox" className="custom-control-input" id="customCheck2"/>
                                    <label className="custom-control-label" id="customCheck2">Create an account</label>
                                </div>
                                <div className="custom-control custom-checkbox d-block">
                                    <input type="checkbox" className="custom-control-input" id="customCheck3"/>
                                    <label className="custom-control-label" id="customCheck3">Ship to a different address</label>
                                </div>
                            </div> */}
                        </div>
                    </form>
                </div>
            </div>
            {/* <div className="col-12 col-lg-4">
                <div className="cart-summary">
                    <h5>Cart Total</h5>
                    <ul className="summary-table">
                        <li><span>subtotal:</span> <span>{`RWF ${cartTotal?.toLocaleString()}`}</span></li>
                        <li><span>delivery:</span> <span>Free</span></li>
                        <li><span>total:</span> <span>{`RWF ${cartTotal?.toLocaleString()}`}</span></li>
                    </ul>

                    <div className="payment-method">
                        <!-- Cash on delivery -->
                        <div className="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" className="custom-control-input" id="cod" checked/>
                            <label className="custom-control-label" >Cash on Delivery</label>
                        </div>
                        <!-- Paypal -->
                        <div className="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" className="custom-control-input" id="paypal"/>
                            <label className="custom-control-label" >Paypal <img className="ml-15" src="img/core-img/paypal.png" alt=""/></label>
                        </div>
                    </div>

                    <div className="cart-btn mt-100">
                        <a href="#" className="btn amado-btn w-100" onClick={handleCheckout}>Checkout</a>
                    </div>
                </div>
            </div> */}
        </div>
    </div>
</div>

)





}

    
    
    </Layout>
  )
}

export default Profile